import { FC } from 'react';

interface InvitationLinkIconProps {
  className?: string;
  color?: string;
  width?: string;
  height?: string;
}

export const InvitationLinkIcon: FC<InvitationLinkIconProps> = ({
  className,
  color = 'currentColor',
  width = '14',
  height = '14',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.2678 1.73223C11.2915 0.755922 9.70854 0.755922 8.73223 1.73223L5.73223 4.73223C4.75592 5.70854 4.75592 7.29146 5.73223 8.26777C5.93948 8.47501 6.17318 8.63769 6.42202 8.75656C6.67119 8.87559 6.77669 9.17407 6.65766 9.42325C6.53863 9.67242 6.24014 9.77792 5.99097 9.65889C5.64113 9.49176 5.31375 9.2635 5.02513 8.97487C3.65829 7.60804 3.65829 5.39196 5.02513 4.02513L8.02513 1.02513C9.39196 -0.341709 11.608 -0.341709 12.9749 1.02513C14.3417 2.39196 14.3417 4.60804 12.9749 5.97487L11.8036 7.14619C11.6083 7.34145 11.2917 7.34145 11.0965 7.14619C10.9012 6.95093 10.9012 6.63434 11.0965 6.43908L12.2678 5.26777C13.2441 4.29146 13.2441 2.70854 12.2678 1.73223ZM7.34234 4.57676C7.46137 4.32759 7.75986 4.22208 8.00903 4.34112C8.35888 4.50824 8.68625 4.7365 8.97487 5.02513C10.3417 6.39196 10.3417 8.60804 8.97487 9.97487L5.97487 12.9749C4.60804 14.3417 2.39196 14.3417 1.02513 12.9749C-0.341709 11.608 -0.341709 9.39196 1.02513 8.02513L2.19644 6.85381C2.3917 6.65855 2.70828 6.65855 2.90355 6.85381C3.09881 7.04908 3.09881 7.36566 2.90355 7.56092L1.73223 8.73223C0.755922 9.70854 0.755922 11.2915 1.73223 12.2678C2.70854 13.2441 4.29146 13.2441 5.26777 12.2678L8.26777 9.26777C9.24408 8.29146 9.24408 6.70854 8.26777 5.73223C8.06052 5.52499 7.82682 5.36232 7.57798 5.24345C7.32881 5.12441 7.22331 4.82593 7.34234 4.57676Z"
      fill={color}
    />
  </svg>
);
